import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=1a2b5dac"
import script from "@/views/modules/ReportAuths/js/DetailView.js?vue&type=script&lang=js&external"
export * from "@/views/modules/ReportAuths/js/DetailView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports